<template>
  <div class="events-category container">
    <h2>{{ $t('homepage.events_category.title') }}</h2>
    <ul class="events-category__items">
      <li v-for="item in elements" :key="item.name">
        <NuxtLink :to="item.link" class="events-category__item">
          <SVGIcon :name="item.name" class="mr10" />
          <p>{{ $t(`homepage.events_category.options.${item.name}`) }}</p>
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const SVGIcon = defineAsyncComponent(() => import('@/components/atoms/SVGIcon.vue'));

const elements = [
  { name: 'bestseller', link: '/motiv?themeCategories_uuid=ca6012ad-e9ea-51ee-8656-624ce7e2148b' },
  { name: 'abstract', link: '/motiv?themeCategories_uuid=20cb6249-a5de-51bf-a0b8-03eb1f31d4cc' },
  { name: 'new', link: '/motiv?themeCategories_uuid=6a6946fa-d29f-50e8-b746-25e976cdee90' },
  { name: 'landscape', link: '/motiv?themeCategories_uuid=3c5458f3-1bbf-574d-9b6a-8e6401d64850' },
  { name: 'nature', link: '/motiv?themeCategories_uuid=24ea0c30-295f-5481-9698-6a3a25e1754b' },
  { name: 'people', link: '/motiv?themeCategories_uuid=1c0029c1-731f-502a-9675-1dc2648d2c96' },
  { name: 'animals', link: '/motiv?themeCategories_uuid=ef48342d-7c96-5e48-aba6-339d843840ce' },
  { name: 'street', link: '/motiv?themeCategories_uuid=15eb7be1-08db-5296-80a2-1b0b1e749610' },
  { name: 'limited', link: '/motiv?themeCategories_uuid=b7369569-cddf-54dc-9928-9a1ac3519f53' },
  { name: 'specials', link: '/motiv?themeCategories_uuid=f6a82b86-420d-598a-b260-77f4943a7d1f' },
  { name: 'seasonal', link: '/motiv?themeCategories_uuid=dc7822bd-39d6-5677-84db-ec8b3e434baa' },
  { name: 'kids', link: '/motiv?themeCategories_uuid=669864c6-6ac1-5423-b9c6-992a1249268b' },
  { name: 'watercolor', link: '/motiv?themeCategories_uuid=102354f8-071a-5d23-9704-b14724887543' },
  { name: 'classic', link: '/motiv?themeCategories_uuid=175596a3-79f3-5fbc-9a42-ecb31d696a0b' },
  { name: 'faces', link: '/motiv?themeCategories_uuid=9e994a76-dc67-5174-85c4-058ad920c866' },
  { name: 'symbols', link: '/motiv?themeCategories_uuid=261af659-ae97-576b-8153-56b55c4537cc' },
  { name: 'beats', link: '/motiv?themeCategories_uuid=839eecae-e68f-51a3-b71e-de148544a263' }
];
</script>

<style lang="scss" scoped>
@use '@/assets/styles/css_BASE/helpers/mixins/_bp.scss' as *;
@use '@/assets/styles/css_BASE/helpers/mixins/font-size.scss' as *;

.events-category {
  margin-top: 40px;
  text-align: center;
  ul {
    list-style-type: none;
    padding-left: 0; /* Optional: Remove the left padding */
  }

  &__items {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  &__item {
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    @include font-size(16px);
    font-weight: 700;
    line-height: 130%;
    border: solid 1px var(--color-indigo-100);
    border-radius: 8px;
    padding: 6px 12px;
    margin: 6px;

    @include bp(md) {
      padding: 8px 18px;
      margin: 12px;
      height: 40px;
      box-sizing: border-box;

      transition: all 0.2s ease-in-out;

      &:hover {
        box-shadow: 0 0 5px var(--color-indigo-100);
        cursor: pointer;
      }
    }
  }
}
</style>
